import React, { Component } from 'react';
import { Button, Form, message, Modal, Select } from 'antd';

import { queryImportBooksIncome } from '@api/finance/finance';
import baseData from '@util/base';
import UploadFile from '@comm/upload/UploadFile';

const FormItem = Form.Item;
const { Option } = Select;

class DetailModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      content: {},
      loading: false,
    };
  }

  submit = e => {
    if (e) {
      e.preventDefault();
    }

    const income = this.props.form.getFieldsValue();

    const obj = Object.assign(this.state.content, income);
    if (this.state.licenseFile && this.state.licenseFile.length > 0) {
      obj.fileUuid = this.state.licenseFile[0].uuid;
    }
    obj.bookUuid = this.props.uuid;
    const { handleSubmit } = this.props;
    this.props.form.validateFields(err => {
      if (!err) {
        this.setState({ loading: true });
        queryImportBooksIncome(obj).then(res => {
          if (res.statusCode === 200) {
            message.success(res.message);
            handleSubmit(obj);
          } else if (res.statusCode === 250) {
            message.warn(res.message);
          } else {
            message.error(res.message);
          }
          this.setState({ loading: false });
        });
      }
    });
  };

  handlelicenseFile = fileList => {
    this.setState({
      licenseFile: fileList,
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };

    const licenseFile = this.state.licenseFile || [];
    return (
      <Modal
        title="导入"
        visible
        onCancel={this.props.cancel}
        onOk={this.submit}
        footer={[
          <Button key="back" onClick={this.props.cancel}>
            取消
          </Button>,
          <Button key="submit" type="primary" loading={this.state.loading} onClick={this.submit}>
            确定
          </Button>,
        ]}
      >
        <Form layout="horizontal">
          <FormItem label="请选择开户银行" {...formItemLayout}>
            {getFieldDecorator('bookType', {
              rules: [{ required: true, message: '请选择收支类型' }],
            })(
              <Select>
                {baseData.bookType.map(item => {
                  return (
                    <Option key={item.key} value={item.key}>
                      {item.name}
                    </Option>
                  );
                })}
              </Select>,
            )}
          </FormItem>
          <FormItem label="上传Excel文件" {...formItemLayout} required>
            <UploadFile
              type="ghost"
              handleUpload={this.handlelicenseFile}
              fileList={licenseFile}
              isExcel
            />
            <span className="ant-form-text">&nbsp;仅限excel格式</span>
          </FormItem>
        </Form>
      </Modal>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(DetailModal);



// WEBPACK FOOTER //
// ./src/components/finance/capital/detail/ModalImportExcel.js